module.exports = __webpack_public_path__ + "static/media/voix-du-midi.5e58c2eb.jpg";